module.exports = __webpack_public_path__ + "media/images/athletes/990-87f1b4046c27d954ed4c458aef330dcf.png";